import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 6v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2h3v-2a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v4.394a2 2 0 0 1 -.336 1.11l-1.328 1.992a2 2 0 0 0 -.336 1.11v1.394m0 4v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-7.394a2 2 0 0 0 -.336 -1.11l-1.328 -1.992a2 2 0 0 1 -.336 -1.11v-4.394","key":"svg-0"}],["path",{"d":"M10 21v-5a2 2 0 1 1 4 0v5","key":"svg-1"}],["path",{"d":"M3 3l18 18","key":"svg-2"}]]

const IconTowerOff = createReactComponent('outline', 'tower-off', 'TowerOff', __iconNode);

export default IconTowerOff;